require('./composeView.scss');
const controller = require('./composeViewCtrl').default;
const template = require('./composeView.html');

require('angular-elastic');
require('ng-focus-if');

const deps = [
  'monospaced.elastic',
  'focus-if',
  require('ui/web/constants').name,
  require('ui/web/oldMessagePayload').name,
  require('ui/web/messagePreview').name,
  require('data/model/clientSettings').name,
  require('data/user').name,
  require('data/model/dashboardClient').name,
  require('data/service/notifications').name,
  require('data/service/featureFlagService').name,
  require('data/model/client').name,
  require('data/model/person').name,
];

module.exports = angular.module('bench.ui.composeView', deps).component('blComposeView', {
  bindings: {
    clientName: '@',
    placeholder: '@',
    composeModeEnabled: '=',
    isDisabled: '=',
    message: '=ngModel',
    onSend: '&',
    onToggleRequestsView: '&',
  },
  template,
  controller,
  controllerAs: 'vm',
});
